/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function toggleDiscountsOnDateTimePassed(date, time, timezoneOffset = 0) {
  const discountElements = document.querySelectorAll('.discount-active');
  const now = new Date();
  const dateParts = date.split('-');
  const timeParts = time.split(':');
  const targetTime = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), parseInt(timeParts[0]), parseInt(timeParts[1]));
  targetTime.setUTCMinutes(targetTime.getUTCMinutes() + timezoneOffset);
  console.log (now);
  if (now >= targetTime) {
    discountElements.forEach(element => {
      element.classList.toggle('hidden');
    });
  }
}


function toggle() {
    var ele = document.getElementById("toggleText");
    var text = document.getElementById("displayText");
    if(ele.style.display == "block") {
            ele.style.display = "none";
        text.innerHTML = "mehr...";
    }
    else {
        ele.style.display = "block";
        text.innerHTML = "weniger...";
    }
} 



document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('a.anchor'); // Get all anchor links with class "anchor"
    const headings = document.querySelectorAll('h2'); // Get all h2 elements

    // Assign unique IDs to each h2 element based on its position
    headings.forEach((heading, index) => {
        const sectionId = `section-${index}`; // Generate a unique id with the correct pattern (section-0, section-1, etc.)
        heading.id = sectionId; // Assign the id to the h2 element
        console.log(`Assigned ID ${sectionId} to heading: ${heading.innerText}`); // Debugging line
    });

    // Now loop through each anchor link
    links.forEach((link) => {
        const linkText = link.innerText.trim(); // Get the text inside the link
        console.log(`Looking for heading matching link: "${linkText}"`);

        // Use Array.from to make sure we can use find() on the NodeList
        const matchingHeading = Array.from(headings).find(heading => {
            return heading.innerText.trim() === linkText; // Compare trimmed text content
        });

        if (matchingHeading) {
            console.log(`Found matching heading: ${matchingHeading.innerText} with ID ${matchingHeading.id}`);
            // Use the ID of the matched h2 element for the link href
            link.setAttribute('href', `#${matchingHeading.id}`);
        } else {
            console.log(`No match found for link: ${linkText}`);
        }
    });
});
// Function to get the value of a specific cookie by name
function getCookieValue(cookieName) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

// Function to store discount code in sessionStorage from the cookie
function storeDiscountCodeFromCookie() {
    const discountCookieName = "discount_code"; // Shopify's discount cookie name
    const discountCode = getCookieValue(discountCookieName); // Get the discount code from the cookie

    if (discountCode) {
        sessionStorage.setItem('discount_code', discountCode); // Store it in sessionStorage
    }
}

// Function to parse discount code to extract discount percentage
function parseDiscountCode(discountCode) {
  const match = discountCode.match(/(.+)_([\d]+)$/); // Regex to extract name and percentage
  
  if (match) {
    return {
      name: match[1],
      percentage: parseInt(match[2], 10),
    };
  }

  // Special case: VOLUME-UP always gets 10%
  if (discountCode.toUpperCase() === "VOLUME-UP") {
    return {
      name: discountCode,
      percentage: 10,
    };
  }

  // Default fallback
  return {
    name: discountCode,
    percentage: 0,
  };
}


// Function to apply discount to the product page (if applicable)
function applyDiscountToProductPage() {
    const discountKey = "discount_code";
    const discountCode = sessionStorage.getItem(discountKey);

    if (discountCode) {
        const discountBadge = document.getElementById("discount-badge");
        if (discountBadge) {
            discountBadge.style.display = "flex";

            const { name, percentage } = parseDiscountCode(discountCode);

            const discountCodeSpan = document.getElementById("discount-code");
            const discountedPriceSpan = document.getElementById("discounted-price");

            if (discountCodeSpan && discountedPriceSpan) {
                const originalPriceElement = document.querySelector(".original-price");
                if (originalPriceElement) {
                    const priceText = originalPriceElement.textContent.trim();
                    const originalPrice = parseFloat(priceText.replace(/[^\d.,-]/g, '').replace(',', '.'));

                    if (!isNaN(originalPrice)) {
                        const discountAmount = originalPrice * (percentage / 100); // Correct discount calculation
                        const discountedPrice = originalPrice - discountAmount;

                        // Update the text to match the desired format
                        discountCodeSpan.textContent = `${name} (-€${discountAmount.toFixed(2)})`;
                        discountedPriceSpan.textContent = `€${discountedPrice.toFixed(2)}`;
                    } else {
                        console.error("Could not parse original price:", priceText);
                    }
                }
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[action*="/cart/add"]');
  const upsellCheckbox = document.querySelector('.upsell-checkbox');

  if (!form || !upsellCheckbox) return;

  // --- HILFSFUNKTION: Drawer chirurgisch aktualisieren & öffnen ---
  async function updateAndOpenDrawer() {
    try {
      // 1. Frisches HTML holen
      const res = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
      const text = await res.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(text, 'text/html');

      // 2. Den richtigen Container finden (Prestige nutzt oft Drawer__Content oder cart-drawer-items)
      // Wir suchen das Formular oder den inneren Content-Wrapper, NICHT den ganzen Drawer
      const selectors = ['#CartDrawer-Form', 'form[action="/cart"]', '.Drawer__Content', 'cart-drawer-items'];
      
      let newContent = null;
      let currentContent = null;

      // Wir gehen die Liste durch und nehmen das erste Match, das in BEIDEN (alt & neu) existiert
      for (const sel of selectors) {
        newContent = newDoc.querySelector(sel);
        currentContent = document.querySelector(`cart-drawer ${sel}`) || document.querySelector(`#sidebar-cart ${sel}`);
        if (newContent && currentContent) break;
      }

      // 3. Inhalt austauschen (Layout-sicher)
      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
        
        // Evtl. Attribute übertragen (falls Klassen am Wrapper hängen)
        if(newContent.className) currentContent.className = newContent.className;
      }

      // 4. Drawer öffnen (Theme-Methoden)
      const drawer = document.querySelector('cart-drawer') || document.getElementById('sidebar-cart');
      
      if (drawer) {
         // Methode A: Offizielle Prestige 2.0 API
         if (typeof drawer.open === 'function') {
           drawer.open();
         } 
         // Methode B: Event Dispatching (funktioniert in vielen Versionen)
         else {
           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
           setTimeout(() => document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true })), 100);
         }
         
         // Methode C: Harter Attribut-Zwang (falls A & B versagen)
         setTimeout(() => {
           if (drawer.getAttribute('aria-hidden') === 'true' || !drawer.hasAttribute('open')) {
             drawer.setAttribute('open', '');
             drawer.setAttribute('aria-hidden', 'false');
             drawer.classList.add('is-open'); // Sicher ist sicher
             
             // Overlay aktivieren
             const overlay = document.querySelector('.PageOverlay');
             if(overlay) overlay.classList.add('is-visible');
           }
         }, 300);
      }

    } catch (e) {
      console.error("Fehler beim Drawer-Update:", e);
      window.location.href = '/cart';
    }
  }

  // --- HAUPTLOGIK ---
  form.addEventListener('submit', async (e) => {
    if (!upsellCheckbox.checked) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const submitBtn = form.querySelector('[type="submit"], [name="add"]');
    const originalText = submitBtn ? submitBtn.innerText : '';
    
    if (submitBtn) {
      submitBtn.classList.add('loading');
      submitBtn.innerText = '...'; 
    }

    const formData = new FormData(form);
    const items = [
      { id: Number(formData.get('id')), quantity: 1 },
      { id: Number(upsellCheckbox.dataset.upsellVariantId), quantity: 1 }
    ];

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (response.ok) {
        upsellCheckbox.checked = false;
        upsellCheckbox.dispatchEvent(new Event('change'));
        
        // HIER STARTET DAS UPDATE
        await updateAndOpenDrawer();
        
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      window.location.href = '/cart';
    } finally {
      if (submitBtn) {
        submitBtn.classList.remove('loading');
        submitBtn.innerText = originalText;
      }
    }
  }, true);
});



document.addEventListener("DOMContentLoaded", function() {
  
  function updateDiscountedUnitPrices() {
    // Sucht sowohl die Produktkarten (Collection) als auch den Preis-Block (Produktseite)
    const priceContainers = document.querySelectorAll('product-card, .product-info__block-item');

    priceContainers.forEach(container => {
      // Sucht den Badge nach der Klasse auf der Collection-Page ODER der Klasse auf der Produktseite
      const badgeElement = container.querySelector('.discounted-price__badge, .ddp-discounted-price__badge');
      
      // Sucht gezielt das selbst eingefügte Element (da es die zusätzliche Klasse 'unit-price' trägt)
      const unitPriceElement = container.querySelector('unit-price.unit-price'); 

      if (badgeElement && unitPriceElement) {
        // Verhindert Endlosschleifen
        if (unitPriceElement.hasAttribute('data-discount-applied')) return;

        // 1. Rabatt-Prozentzahl aus dem Badge auslesen
        const badgeText = badgeElement.textContent;
        const percentageMatch = badgeText.match(/(\d+)%/);

        if (percentageMatch) {
          const discountPercent = parseFloat(percentageMatch[1]);

          // 2. Aktuellen Text des Grundpreises auslesen
          const unitText = unitPriceElement.textContent;
          
          // Zahl extrahieren
          const priceMatch = unitText.match(/(\d+(?:\.\d+)?(?:,\d{1,2})?)/);

          if (priceMatch) {
            const priceString = priceMatch[1];
            
            // Format für die Berechnung umwandeln
            const priceFloat = parseFloat(priceString.replace(/\./g, '').replace(',', '.'));

            // 3. Neuen Preis berechnen
            const newPrice = priceFloat * (1 - (discountPercent / 100));

            // 4. Zurück in deutsches Währungsformat umwandeln
            const newPriceString = newPrice.toFixed(2).replace('.', ',');

            // 5. Text ersetzen
            unitPriceElement.textContent = unitText.replace(priceString, newPriceString);

            // 6. Element markieren
            unitPriceElement.setAttribute('data-discount-applied', 'true');
          }
        }
      }
    });
  }

  // MutationObserver, da die Rabatt-App die Badges asynchron (nachträglich) lädt
  const observer = new MutationObserver((mutations) => {
    updateDiscountedUnitPrices();
  });

  // Gesamten Body auf Änderungen überwachen
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initiale Ausführung beim Laden der Seite
  updateDiscountedUnitPrices();
});
